import { render, staticRenderFns } from "./BarOrderMode.vue?vue&type=template&id=18baf4bc&scoped=true"
import script from "./BarOrderMode.vue?vue&type=script&lang=js"
export * from "./BarOrderMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18baf4bc",
  null
  
)

export default component.exports